import { GomarkePixelConfig } from '../types';
// import type { ViewportSelectorType } from '../behavior/types';

/**
 * Lê do script tag o bootstrap (pixel id, endpoint, apiKey, debug, timeout, behavior).
 * A config completa vem de getSetting – use getConfigFromScriptTag() em getSetting.ts.
 */
export const parseConfigFromScriptTag = (
  scriptTag: HTMLScriptElement
): GomarkePixelConfig => {
  const config: GomarkePixelConfig = {
    pixel: scriptTag.getAttribute('data-pixel') || '',
    apiEndpoint:
      scriptTag.getAttribute('data-api-endpoint') ||
      'https://micro-servico-pixel-develop.up.railway.app',
    debug: scriptTag.getAttribute('data-debug') === 'true',
    timeout: parseInt(scriptTag.getAttribute('data-timeout') || '5000'),
    projectId: scriptTag.getAttribute('data-project-id') || '',
    pageId: scriptTag.getAttribute('data-page-id') || '',
  };

  return config;
};
